import { Decimal } from 'decimal.js';

const MC_DEFAULT = new Decimal(0.2);

export function calculateStopLossLimit( isShort: boolean,
                                   inputCcyEqualsBaseCcy: boolean, // always false
                                   multiplier: number, // leverage
                                   initialPrice: Decimal | string | number = 0, // open price
                                   mcDefault = MC_DEFAULT) {
    let mcPricePct: Decimal = new Decimal(0);
    let mcPrice: Decimal = new Decimal(0);

    if (!isShort && !inputCcyEqualsBaseCcy) {
        mcPricePct = Decimal.sub(1, mcDefault).div(multiplier);
        mcPrice = Decimal.sub(1, mcPricePct).mul(initialPrice);
    } else if (!inputCcyEqualsBaseCcy) {
        mcPricePct = Decimal.sub(1, mcDefault).div(multiplier - 1);
        mcPrice = Decimal.add(1, mcPricePct).mul(initialPrice);
    } else if (!isShort && inputCcyEqualsBaseCcy) {
        mcPricePct = Decimal.sub(1, mcDefault).div(multiplier);
        mcPrice = Decimal.sub(1, mcPricePct).mul(initialPrice);
    } else if (inputCcyEqualsBaseCcy) {
        mcPricePct = Decimal.sub(1, mcDefault).div(multiplier - 1);
        mcPrice = Decimal.add(1, mcPricePct).mul(initialPrice);
    }

    return mcPrice;
}

export function calculateTakeProfitLimit(isShort: boolean,
                                    inputCcyEqualsBaseCcy: boolean,
                                    multiplier: number,
                                    initialPrice: Decimal | number | string = 0,
                                    defaultFtp: Decimal | number | string) {
    let ftpPricePct: Decimal;
    let ftpPrice = new Decimal(0);

    defaultFtp = new Decimal(defaultFtp);
    initialPrice = new Decimal(initialPrice);

    if (!isShort && !inputCcyEqualsBaseCcy) {
        ftpPricePct = defaultFtp.div(multiplier);
        ftpPrice = Decimal.add(1, ftpPricePct).mul(initialPrice);
    } else if (!inputCcyEqualsBaseCcy) {
        ftpPricePct = defaultFtp.div(multiplier - 1);
        ftpPrice = initialPrice.div(Decimal.add(1, ftpPricePct));
    } else if (!isShort && inputCcyEqualsBaseCcy) {
        ftpPricePct = defaultFtp.div(multiplier - 1);
        ftpPrice = Decimal.add(1, ftpPricePct).mul(initialPrice);
    } else if (inputCcyEqualsBaseCcy) {
        ftpPricePct = defaultFtp.div(multiplier);
        ftpPrice = initialPrice.div(Decimal.add(1, ftpPricePct));
    }

    return ftpPrice;
}


const FTP_DEFAULT_UP = 1.4;
const FTP_DEFAULT_DOWN = 1.5;
const FTP_DEFAULT_DOWN_SOLANA = 1.4;
const VOLATILITY_COEFFICIENT = 0.03;

export function calculateStopLossLimitWithVolatility(isShort: boolean, leverage: number | string, price: number | string) {

    const stopLossLimit = calculateStopLossLimit(
        isShort,
        false,
        Number(leverage) || 1,
        price,
    );

    const volatilityCoef = new Decimal(VOLATILITY_COEFFICIENT).div(leverage);

    const volatilityCoefficient = isShort ? new Decimal(1).minus(volatilityCoef) : new Decimal(1).plus(volatilityCoef);
    const stopLossLimitWithVolatility = stopLossLimit.mul(volatilityCoefficient);
    return stopLossLimitWithVolatility;

}
export function calculateTakeProfitLimitWithVolatility(isShort: boolean, leverage: number | string, price: number | string, baseAsset: string) {

    const ftp = isShort ? (baseAsset.toUpperCase() === 'SOL' ? FTP_DEFAULT_DOWN_SOLANA : FTP_DEFAULT_DOWN) : FTP_DEFAULT_UP;

    const takeProfitLimit = calculateTakeProfitLimit(
        isShort,
        false,
        Number(leverage) || 1,
        price,
        ftp
    );

    const volatilityCoef = new Decimal(VOLATILITY_COEFFICIENT).div(leverage);

    const volatilityCoefficient = isShort ? new Decimal(1).plus(volatilityCoef) :  new Decimal(1).minus(volatilityCoef);
    const takeProfitLimitWithVolatility = takeProfitLimit.mul(volatilityCoefficient);
    return takeProfitLimitWithVolatility;
}